import React from 'react'
import './Blogs.css'

export default function Blogs() {
  return (
    <div className="blogs-container">
            <div className="clients-header slide-in-right">
        <h3>the reflections..</h3>
      </div>
      <div className="blogs-content slide-in-left">
      <a target="_blank"
          rel="noopener noreferrer" href="https://medium.com/@darnycya/6-facts-to-know-before-enrolling-into-a-coding-bootcamp-994a16392fd4?source=user_profile_page---------2-------------f791a959f30f----------------------"><img src="/blog1.png" alt="medium-blog1" /></a>
      <a target="_blank"
          rel="noopener noreferrer" href="https://medium.com/@darnycya/rethinking-tech-job-hopping-understanding-the-impact-of-layoffs-on-candidates-399d8d91341d?source=user_profile_page---------1-------------f791a959f30f----------------------"><img src="/blog2.png" alt="medium-blog2" /></a>
        <a target="_blank"
          rel="noopener noreferrer" href="https://medium.com/@darnycya/navigating-api-hosting-alternatives-in-a-post-heroku-free-era-944e9b167c90?source=user_profile_page---------0-------------f791a959f30f----------------------"><img src="/blog3.png" alt="medium-blog3" /></a>
        </div>
    </div>
  )
}
